/* Lecteur de reels video — fiche produit.
   Extrait de product.json (custom_liquid_TecNUH) pour etre mis en cache.
   Les donnees (lesReels) restent inline car dependantes des tags produit. */
var lesReels = window.lesReels || [];

var isPlaying = false;

  var currentVideoIndex = 0;

  var indexReel = 0;

  var videoPlaylist = [];

  var timeoutID = null;

  var displayNavbar = document.querySelector('.header');

  var btnSong = document.querySelector('.song-btn');

  var videoDisplay = document.querySelector('#video-player');

  var btnPause = document.querySelector('.pause-btn');


if (videoDisplay) {
  videoDisplay.addEventListener('ended', btn_right);
  videoDisplay.addEventListener('timeupdate', barProgression);

  videoDisplay.muted = true;
  
  var on = document.querySelector('.diffuseurAllume');
  var off = document.querySelector('.diffuseurEteint');
  if (on) on.style.display = 'none';
  if (off) off.style.display = 'block';
}

if (btnSong) btnSong.addEventListener('click', muteSong);
if (btnPause) btnPause.addEventListener('click', takePauseVideo);

  function barProgression() {

    var bar = document.querySelector('.active');

    if (!bar || !videoDisplay || !videoDisplay.duration) return;

    var percent = (videoDisplay.currentTime / videoDisplay.duration) * 100;

    // Remplit la barre de gauche à droite en temps réel

    bar.style.background = `linear-gradient(to right, #FFFFFF ${percent}%, rgba(255,255,255,0.3) ${percent}%)`;

  }


  function takePauseVideo() {

    if (!videoDisplay) return;

    var s = document.querySelector('.suspend-btn');

    var p = document.querySelector('.play-btn');

    if (!videoDisplay.paused) {

      videoDisplay.pause();

      if (s) s.style.display = 'none';

      if (p) p.style.display = 'block';

    } else {

      videoDisplay.play();

      if (s) s.style.display = 'block';

      if (p) p.style.display = 'none';

    }

  }


 function muteSong() {
    if (!videoDisplay) return;

    var on = document.querySelector('.diffuseurAllume');
    var off = document.querySelector('.diffuseurEteint');

    videoDisplay.muted = !videoDisplay.muted;

    if (on) on.style.display = videoDisplay.muted ? 'none' : 'block';
    if (off) off.style.display = videoDisplay.muted ? 'block' : 'none';
}


if (btnSong) {
    btnSong.addEventListener('click', muteSong);
}


  function openVideo(videoUrls) {

    indexReel = lesReels.findIndex(function(reel) {

      return JSON.stringify(reel) === JSON.stringify(videoUrls);

    });

    if(indexReel === -1) indexReel = 0; // Sécurité

    

    videoPlaylist = videoUrls;

    isPlaying = true;

    currentVideoIndex = 0; // On commence toujours à la première vidéo de la série

    

    if (displayNavbar) displayNavbar.style.display = 'none';

    document.querySelector('body').style.overflowY = 'hidden';

    var m = document.querySelector('marquee-text');

    if (m) m.style.display = 'none';

    var c = document.querySelector('.content-tabs');

    if (c) c.style.visibility = 'hidden';

    playNextVideo();

  }


  function playNextVideo() {

    if (!isPlaying || !videoDisplay) return;

    var modal = document.getElementById('video-modal');

    var videoPlayer = document.getElementById('video-player');

    var sourceElement = document.getElementById('video-source');

    var iframePlayer = document.getElementById('youtube-player');

    

    updateProgressBars();

    

    var url = videoPlaylist[currentVideoIndex];

    if (url.includes('youtube.com') || url.includes('youtu.be')) {

      videoPlayer.style.display = 'none';

      iframePlayer.style.display = 'block';

      iframePlayer.src = 'about:blank';

      setTimeout(() => { iframePlayer.src = convertToYouTubeEmbed(url); }, 100);

    } else {

      videoPlayer.style.display = 'block';

      iframePlayer.style.display = 'none';

      videoPlayer.src = url;

      sourceElement.setAttribute('src', url);

      videoPlayer.load();

      videoPlayer.play();

    }

    modal.style.display = 'block';

  }


  function convertToYouTubeEmbed(url) {

    let id = '';

    if (url.includes('shorts/')) id = url.split('shorts/')[1].split('?')[0];

    else if (url.includes('watch?v=')) id = url.split('v=')[1].split('&')[0];

    else if (url.includes('youtu.be/')) id = url.split('youtu.be/')[1].split('?')[0];

    if (!id) return '';

    return `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&enablejsapi=1&origin=${window.location.origin}`;

  }


  function updateProgressBars() {

    var container = document.getElementById('progress-bars');

    container.innerHTML = '';

    for (var i = 0; i < videoPlaylist.length; i++) {

      var bar = document.createElement('div');

      bar.classList.add('progress-bar');

      

      if (i < currentVideoIndex) {

        // Vidéos précédentes : barre pleine (blanche)

        bar.style.background = '#FFFFFF';

      } else if (i === currentVideoIndex) {

        // Vidéo en cours : prête à être remplie par le timeupdate

        bar.classList.add('active');

        bar.style.background = 'rgba(255,255,255,0.3)';

      } else {

        // Vidéos suivantes : barre vide (transparente)

        bar.style.background = 'rgba(255,255,255,0.3)';

      }

      

      container.appendChild(bar);

    }

  }


  function btn_right() {

    if (currentVideoIndex < videoPlaylist.length - 1) {

      currentVideoIndex++;

      clearTimeout(timeoutID);

      playNextVideo();

    } else {

      // Fin des vidéos du Reel en cours -> Passe au Reel suivant

      btn_right_reel();

    }

  }


  function btn_left() {

    if (currentVideoIndex > 0) {

      currentVideoIndex--;

      clearTimeout(timeoutID);

      playNextVideo();

    } else {

      // Première vidéo du Reel -> Passe au Reel précédent

      btn_left_reel();

    }

  }


  // --- NOUVELLES FONCTIONS DE NAVIGATION DE STORY EN STORY ---


  function btn_right_reel() {

    if (lesReels.length <= 1) return; // S'il n'y a qu'une story sur le produit

    indexReel = (indexReel + 1) % lesReels.length; // Boucle au début à la fin

    openVideo(lesReels[indexReel]);

  }


  function btn_left_reel() {

    if (lesReels.length <= 1) return;

    indexReel = (indexReel - 1 + lesReels.length) % lesReels.length; // Boucle à la fin si on recule

    openVideo(lesReels[indexReel]);

  }


  // -------------------------------------------------------------


  function closeVideo() {

    clearTimeout(timeoutID);

    isPlaying = false;

    currentVideoIndex = undefined;

    var modal = document.getElementById('video-modal');

    var videoPlayer = document.getElementById('video-player');

    var iframePlayer = document.getElementById('youtube-player');

    if (videoPlayer) { videoPlayer.pause(); videoPlayer.style.display = 'none'; }

    if (iframePlayer) { iframePlayer.style.display = 'none'; iframePlayer.src = 'about:blank'; }

    if (modal) modal.style.display = 'none';

    if (displayNavbar) displayNavbar.style.display = 'grid';

    document.querySelector('body').style.overflowY = 'scroll';

    var m = document.querySelector('marquee-text');

    if (m) m.style.display = 'block';

    var c = document.querySelector('.content-tabs');

    if (c) c.style.visibility = 'visible';

  }
